const publicationDict = {
    "0": {
        "title": "P4-TAS: P4-Based Time-Aware Shaper for Time-Sensitive Networking",
        "short": "P4-TAS",
        "date": "08 April 2026",
        "venue": "IEEE Open Journal of the Communications Society",
        "authors": "Fabian Ihle, Moritz Flüchter, Michael Menth",
        "link": "https://doi.org/10.1109/OJCOMS.2026.3682460",
        "type": "journal"
    },
    "1": {
        "title": "Rust Barefoot Runtime (RBFRT): Fast Runtime Control for the Intel Tofino",
        "short": "RBFRT",
        "date": "28 January 2025",
        "venue": "4th KuVS Workshop on Network Softwarization (KuVS NetSoft), University of Tübingen",
        "authors": "Etienne Zink, Moritz Flüchter, Steffen Lindner, Fabian Ihle, Michael Menth",
        "link": "https://arxiv.org/abs/2501.17271",
        "type": "workshop"
    },
    "2": {
        "title": "UniCorn-P4: A Universal Control Plane and GUI for P4",
        "short": "UniCorn-P4",
        "date": "30 September 2025",
        "venue": "Universität Würzburg",
        "authors": "Fabian Ihle, Moritz Flüchter, Steffen Lindner, Michael Menth",
        "link": "https://atlas.cs.uni-tuebingen.de/~ihle/IhFl24.pdf",
        "type": "workshop"
    },
    "3": {
        "title": "Autonomous integration of TSN-unaware applications with QoS requirements in TSN networks",
        "short": "TSN-unaware Integration",
        "date": "01 June 2024",
        "venue": "Computer Communications 222, 118-129",
        "authors": "Moritz Flüchter, Steffen Lindner, Lukas Osswald, Jérôme Arnaud, Michael Menth",
        "link": "https://www.sciencedirect.com/science/article/pii/S0140366424001439",
        "type": "journal"
    },
    "4": {
        "title": "Extensions to BIER Tree Engineering (BIER-TE) for Large Multicast Domains and 1:1 Protection",
        "short": "BIER-TE Subset Extension",
        "date": "15 June 2026",
        "venue": "Journal of Network and Computer Applications",
        "authors": "Moritz Flüchter, Steffen Lindner, Fabian Ihle, Toerless Eckert, Michael Menth",
        "link": "https://www.sciencedirect.com/science/article/pii/S1084804526001153",
        "type": "journal"
    },
}

export default publicationDict;
